<style scoped lang="scss">
.message-icon {
  margin-left: 10px;
}
.male-icon {
  color: $male;
}
.female-icon {
  color: $female;
}
</style>

<template>
  <td :class="{ 'table-danger': isDeleted }">
    <router-link :to="link">
      <img height="45" width="45" class="rounded-circle mr-2 link" :src="src" />
      {{ profile.name }}
      <i v-if="profile.sex == 'männlich'" class="fas fa-mars male-icon"></i>
      <i
        v-else-if="profile.sex == 'weiblich'"
        class="fas fa-venus female-icon"
      ></i>
    </router-link>
    <span v-if="messageCount !== null">
      <i class="fas fa-comments message-icon"></i>
      {{ messageCount }}
    </span>
  </td>
</template>

<script>
export default {
  props: {
    profile: {
      type: Object,
      required: true
    },
    messageCount: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    src() {
      return `${this.profile.primary_image.url}?width=45&height=45`;
    },
    isDeleted() {
      return this.profile.deleted_at !== null;
    },
    link() {
      return this.profile.is_fake
        ? `/fake/kartei/${this.profile.id}`
        : `/mitglieder/kartei/${this.profile.id}`;
    }
  }
};
</script>
